import React from 'react';
import { TileActionHandlerProps } from '../types';
import CaptureDetailsAction from './captureDetailsAction';
import RedirectAction from './redirectAction';
import ShowFormAction from './showFormAction';
import ShowTextAction from './showTextAction';

function TileActionHandler({
  action,
  error,
  widgetCode,
}: TileActionHandlerProps): JSX.Element | null {
  if (!action) return null;

  switch (action.type) {
    case 'REDIRECT':
      return <RedirectAction action={action} widgetCode={widgetCode} />;
    case 'SHOW_TEXT':
      return <ShowTextAction action={action} widgetCode={widgetCode} />;
    case 'CAPTURE_DETAILS':
      return (
        <CaptureDetailsAction
          action={action}
          error={error}
          widgetCode={widgetCode}
        />
      );
    case 'SHOW_FORM':
      return <ShowFormAction action={action} widgetCode={widgetCode} />;
    default:
      return null;
  }
}

export default TileActionHandler;
